import React, { useEffect, useState } from "react";
import { useUserContext } from "context/UserContext";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import axios from "axios";
import { serverUrl } from "utils/utils";
import "./css/WatchList.css";

const WatchList = () => {
  const { userDetails, token } = useUserContext();
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForecasts = async () => {
      try {
        const res = await axios.get(`${serverUrl}/user/getForecasts`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const allForecasts = res.data;
        const symbols = userDetails?.watchList ?? [];

        const filtered = allForecasts.filter((coin) => symbols.includes(coin.symbol));

        setCoins(filtered);
      } catch (err) {
        console.error("Error fetching watchlist forecasts", err);
      } finally {
        setLoading(false);
      }
    };

    if (userDetails?.watchList?.length) {
      fetchForecasts();
    } else {
      setLoading(false);
    }
  }, [userDetails]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="watchlist-container">
        <h2 className="watchlist-title">רשימת המעקב שלי</h2>

        {loading ? (
          <div className="loading-container">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">טוען...</span>
            </div>
          </div>
        ) : coins.length === 0 ? (
          <p className="text-center mt-4">אין מטבעות במעקב כרגע.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped text-center forecast-table">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>שם</th>
                  <th>סימול</th>
                  <th>מחיר נוכחי ($)</th>
                  <th>תחזית ירידה</th>
                  <th>תחזית עלייה</th>
                  <th>יציבות</th>
                  <th>רווחיות</th>
                  <th>סיבות</th>
                </tr>
              </thead>
              <tbody>
                {coins.map((coin, index) => (
                  <tr key={coin.symbol}>
                    <td>{index + 1}</td>
                    <td>{coin.name || "-"}</td>
                    <td>{coin.symbol}</td>
                    <td>{+coin.currentPrice.toFixed(4)}</td>
                    <td>{+coin.predictedLow.toFixed(4)}</td>
                    <td>{+coin.predictedHigh.toFixed(4)}</td>
                    <td className={coin.stability > 0.95 ? "text-success" : "text-warning"}>
                      {(coin.stability * 100).toFixed(2)}%
                    </td>
                    <td className={coin.profitability > 0.05 ? "text-profit" : "text-loss"}>
                      {(coin.profitability * 100).toFixed(2)}%
                    </td>
                    <td className="text-start reason-cell">{coin.reason || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default WatchList;
